module.exports = __webpack_public_path__ + "static/media/interchange.8e805286.svg";